import * as D3Scale from 'd3-scale';

export const calculateSetDomain = function(data, accessorFunction) {
    return Array.from(new Set(data.map(accessorFunction)));
};

export const calculateSVGXRange = function(width, margins) {
    return [0, width - margins.left - margins.right];
};

export const calculateSVGYRange = function(height, margins) {
    return [height - margins.top - margins.bottom, 0];
};

export const calculateChartBoundaries = function(width, yValueToSVGCoordinateMapper, margins) {
    let ticks = yValueToSVGCoordinateMapper.ticks();
    return {
        'bottom': yValueToSVGCoordinateMapper(ticks[0]),
        'top': yValueToSVGCoordinateMapper(ticks[ticks.length-1]),
        'left': 0,
        'right': width - margins.left - margins.right,
    }
};

export const valueToSVGCoordinateMapper = function(options) {
    const {
        scaleType,
        range,
        domain,
        useNiceDomain,
    } = options;
    if (!scaleType) {
        throw new Error('no scaleType option provided');
    }
    if (!domain) {
        throw new Error('no range option provided');
    }
    if (!range) {
        throw new Error('no domain option provided');
    }
    let map = {
        band: D3Scale.scaleBand,
        identity: D3Scale.scaleIdentity,
        linear: D3Scale.scaleLinear,
        log: D3Scale.scaleLog,
        ordinal: D3Scale.scaleOrdinal,
        pow: D3Scale.scalePow,
        quantile: D3Scale.scaleQuantile,
        quantize: D3Scale.scaleQuantize,
        sqrt: D3Scale.scaleSqrt,
        time: D3Scale.scaleTime,
    };
    let func = map[scaleType];
    if (!func) {
        throw new Error('no function match for scaleType found');
    }
    func = func();
    func.range(range);
    func.domain(domain);
    if (useNiceDomain) {
        func.nice();
    }

    if (scaleType === 'band') {
        func.paddingInner(options.bandPaddingInner || .1);
        func.paddingOuter(options.bandPaddingOuter || .1);
    }
    return func;
};
